import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'youthFidelityReport',
    label: 'Youth Fidelity Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
